/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Noquestionsavailable2Inputs */

const en_questionnaire_noquestionsavailable2 = /** @type {(inputs: Questionnaire_Noquestionsavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No questions available`)
};

const fr_questionnaire_noquestionsavailable2 = /** @type {(inputs: Questionnaire_Noquestionsavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune question disponible`)
};

/**
* | output |
* | --- |
* | "No questions available" |
*
* @param {Questionnaire_Noquestionsavailable2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_noquestionsavailable2 = /** @type {((inputs?: Questionnaire_Noquestionsavailable2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Noquestionsavailable2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_noquestionsavailable2(inputs)
	return fr_questionnaire_noquestionsavailable2(inputs)
});
export { questionnaire_noquestionsavailable2 as "questionnaire_noQuestionsAvailable" }